var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "NewGroupModal",
          attrs: {
            id: "NewGroupModal",
            size: "lg",
            "content-class": "menu-bg-blue-transparent-modal ngm-modal",
            title: "Create Group",
            "hide-footer": "",
          },
          on: {
            show: function ($event) {
              return _vm.initModal()
            },
          },
        },
        [
          _c(
            "b-container",
            [
              _c("b-form-input", {
                attrs: {
                  name: "New Group Name",
                  placeholder: "Group Name",
                  autocomplete: "off",
                },
                model: {
                  value: _vm.form.group_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "group_name", $$v)
                  },
                  expression: "form.group_name",
                },
              }),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-lg float-right",
                          attrs: { variant: "primary", type: "submit" },
                          on: {
                            click: function ($event) {
                              return _vm.checkForm()
                            },
                          },
                        },
                        [_vm._v("\n            Submit\n          ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-lg float-left",
                          attrs: { variant: "secondary", type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.back()
                            },
                          },
                        },
                        [_vm._v("\n            Cancel\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }